/**
 * Content bank for the learning games. Curated (like the placement test) so the
 * games are genuinely useful rather than derived from sparse lesson data.
 *
 * Word pairs are English ↔ Kinyarwanda — a strong fit for our default learner.
 * Translations are best-effort; have a native speaker review before launch
 * (same note as the rw.ts UI strings).
 */

export interface WordPair {
  en: string;
  rw: string;
}

export const WORD_PAIRS: WordPair[] = [
  { en: 'water', rw: 'amazi' },
  { en: 'food', rw: 'ibiryo' },
  { en: 'house', rw: 'inzu' },
  { en: 'friend', rw: 'inshuti' },
  { en: 'book', rw: 'igitabo' },
  { en: 'teacher', rw: 'umwarimu' },
  { en: 'student', rw: 'umunyeshuri' },
  { en: 'work', rw: 'akazi' },
  { en: 'money', rw: 'amafaranga' },
  { en: 'market', rw: 'isoko' },
  { en: 'child', rw: 'umwana' },
  { en: 'mother', rw: 'mama' },
  { en: 'father', rw: 'papa' },
  { en: 'name', rw: 'izina' },
  { en: 'car', rw: 'imodoka' },
  { en: 'road', rw: 'umuhanda' },
  { en: 'school', rw: 'ishuri' },
  { en: 'hospital', rw: 'ibitaro' },
  { en: 'doctor', rw: 'muganga' },
  { en: 'love', rw: 'urukundo' },
  { en: 'sun', rw: 'izuba' },
  { en: 'rain', rw: 'imvura' },
  { en: 'tree', rw: 'igiti' },
  { en: 'dog', rw: 'imbwa' },
  { en: 'cat', rw: 'injangwe' },
  { en: 'bird', rw: 'inyoni' },
  { en: 'milk', rw: 'amata' },
  { en: 'door', rw: 'urugi' },
  { en: 'table', rw: 'ameza' },
  { en: 'chair', rw: 'intebe' },
  { en: 'phone', rw: 'telefone' },
  { en: 'time', rw: 'igihe' },
  { en: 'week', rw: 'icyumweru' },
  { en: 'month', rw: 'ukwezi' },
  { en: 'year', rw: 'umwaka' },
  { en: 'morning', rw: 'igitondo' },
];

/** Short, everyday English sentences for the sentence-builder game. */
export const SENTENCES: string[] = [
  'I am a student.',
  'She works at the hospital.',
  'We are learning English.',
  'He goes to work every day.',
  'They live in Kigali.',
  'The market is very busy.',
  'My name is Aline.',
  'Please open the door.',
  'I would like some water.',
  'The teacher is very kind.',
  'We eat rice for lunch.',
  'Where is the bus stop?',
  'Thank you for your help.',
  'The children are playing outside.',
  'I will call you tomorrow.',
  'She speaks three languages.',
];

export function shuffle<T>(items: T[]): T[] {
  const out = [...items];
  for (let i = out.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [out[i], out[j]] = [out[j]!, out[i]!];
  }
  return out;
}

/** Pick `count` random distinct items. */
export function sample<T>(items: T[], count: number): T[] {
  return shuffle(items).slice(0, count);
}
